const firebaseConfig = {
    apiKey: "AIzaSyBz7-3rPknM3LaQZhlSGSLC2xEccN82Fl8",
    authDomain: "dhaka-metro-rail.firebaseapp.com",
    projectId: "dhaka-metro-rail",
    storageBucket: "dhaka-metro-rail.appspot.com",
    messagingSenderId: "366335692959",
    appId: "1:366335692959:web:5d894e2772a50a75f5d2aa"
  };
  export default firebaseConfig;